import useRoutesHandler from "@/Hooks/useRouteHandler";
import logo from "@/assets/Images";
import { HomeIcon } from "@heroicons/react/24/outline";
import { Image, ButtonBase } from "@repo/ui/index.tsx";

const NotFound = () => {
  const { navigate } = useRoutesHandler();
  const isPartner = import.meta.env.VITE_USER === "partner";
  return (
    <div className="flex h-screen justify-center gap-20 items-center">
      <Image src={logo.Unplugged} className="h-[500px]" />
      <div className="flex flex-col justify-center gap-8">
        <h1 className="text-[5rem] font-bold leading-[4rem] text-body">
          Page not found
        </h1>
        <p className="text-base font-semibold text-body/85">
          Sorry, this page isn&lsquo;t available
        </p>
        <ButtonBase
          text={isPartner ? "Go to Previous Page" : "Go to Homepage"}
          buttonType="tertiary"
          className="w-48 h-11 text-white bg-body rounded-md gap-2 hover:brightness-90 "
          icon={<HomeIcon className="size-5" />}
          onClick={() => {
            if (isPartner) {
              navigate(-1);
            } else {
              navigate("/home");
            }
          }}
        />
      </div>
    </div>
  );
};

export default NotFound;
